const routes = {
  '/admin': 'Home',
  '/admin/dashboard': 'Dashboard',
  '/admin/scheduledreplenishment': 'geplante Nachversorgung',
  '/admin/replenishment': 'ausgeführte Nachversorgung',
  '/admin/areacontrol/overview': 'Flächensteuerung Übersicht',
  '/admin/areacontrol/admin': 'Flächensteuerung verwalten',
  '/admin/modules/overview': 'Modulübersicht',
  '/admin/modules/admin': 'Modulverwaltung',
  '/admin/retailer': 'Händler',
  '/admin/retailer/stores': 'Stores',
  '/admin/retailer/iposconfig': 'IPOS-Konfiguration',
  '/admin/article': 'Artikel',
  '/admin/admin/user': 'Benutzerverwaltung',
  '/admin/admin/sync': 'Synchronization'
};
export default routes;



// WEBPACK FOOTER //
// ./src/admin/routes.js